module.exports = __webpack_public_path__ + "img/weather_windy.7ce98a0a.png";